var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolarPower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,12H4L2,22h20L20,12z M18.36,14l0.4,2H13v-2H18.36z M11,14v2H5.24l0.4-2H11z M4.84,18H11v2H4.44L4.84,18z M13,20v-2 h6.16l0.4,2H13z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    width: 2,
    x: 11,
    y: 8
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -0.2089 14.6085)",
    width: 2,
    x: 16.53,
    y: 6.06
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.448 6.7885)",
    width: 3,
    x: 4.97,
    y: 6.56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 3,
    x: 3,
    y: 2
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 3,
    x: 18,
    y: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,7c2.76,0,5-2.24,5-5h-2c0,1.65-1.35,3-3,3S9,3.65,9,2H7C7,4.76,9.24,7,12,7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarPower);
export default __webpack_public_path__ + "static/media/solar_power.a67ceabf4acc607cb6b208582a1dcf7b.svg";
export { ForwardRef as ReactComponent };